import React, { useEffect, useId, useState } from "react";

export function AdminListToolbar({
  title = "List filters",
  search = "",
  searchLabel = "Search",
  onSearch,
  onReset,
  children,
  total,
  loading = false,
}) {
  const [value, setValue] = useState(search);
  const searchId = useId();
  useEffect(() => setValue(search), [search]);
  return (
    <form
      role="search"
      aria-label={title}
      className="admin-list-toolbar flex min-w-0 w-full max-w-full flex-wrap items-end gap-2 rounded-lg border border-border bg-card p-3"
      onSubmit={(event) => {
        event.preventDefault();
        onSearch(value.trim());
      }}
    >
      <div className="min-w-0 max-w-full flex-[1_1_220px]">
        <label className="mb-1 block text-sm font-medium" htmlFor={searchId}>{searchLabel}</label>
        <input id={searchId} value={value} onChange={(event) => setValue(event.target.value)} maxLength={200} className="min-h-11 w-full rounded-lg border border-input bg-background px-3 py-2 text-sm" />
      </div>
      {children}
      <button type="submit" className="min-h-11 min-w-11 rounded-lg bg-teal-700 px-4 py-2 text-sm font-semibold text-white disabled:opacity-50" disabled={loading}>Apply</button>
      <button type="button" onClick={onReset} className="min-h-11 min-w-11 rounded-lg border border-border px-3 py-2 text-sm font-semibold hover:bg-muted" disabled={loading}>Clear</button>
      <span className="basis-full text-sm text-muted-foreground" role="status" aria-live="polite">
        {loading ? "Loading…" : `${total} result${total === 1 ? "" : "s"}`}
      </span>
    </form>
  );
}

export function AdminListPager({ offset, limit, total, onPage, disabled = false }) {
  const hasPrevious = offset > 0;
  const hasNext = offset + limit < total;
  return (
    <nav aria-label="List pages" className="admin-list-pager flex flex-wrap items-center justify-between gap-2 border-t border-border px-4 py-3 text-sm">
      <span className="text-muted-foreground">{total ? `${offset + 1}–${Math.min(offset + limit, total)} of ${total}` : "0 results"}</span>
      <span className="flex gap-2">
        <button type="button" className="min-h-11 rounded-lg border border-border px-3 py-2 font-semibold disabled:opacity-50" disabled={disabled || !hasPrevious} onClick={() => onPage(Math.max(0, offset - limit))}>Previous</button>
        <button type="button" className="min-h-11 rounded-lg border border-border px-3 py-2 font-semibold disabled:opacity-50" disabled={disabled || !hasNext} onClick={() => onPage(offset + limit)}>Next</button>
      </span>
    </nav>
  );
}
